import { Injectable } from '@angular/core';

@Injectable()
export class LoadingService {
    private showSpinner: boolean = false;

    constructor() {
        this.showSpinner = false;
    }

    mustShowSpinner() {
        return this.showSpinner;
    }

    enableShowSpinner() {
        this.showSpinner = true;
    }

    disableShowSpinner() {
        this.showSpinner = false;
    }
}


// WEBPACK FOOTER //
// D:/Projects/GitHub/education-ee-web/src/app/services/util/loading.service.ts